export const PRODUCT_EMAIL = 'production@elandic.ru';
